import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, Film, Image as ImgIcon } from "lucide-react";
import { Empty, EstadoBadge, Input, Select, Spinner } from "./ui";
import { EnvioDetail } from "./EnvioDetail";
import { errMsg, fmtDate } from "./api";

const ESTADOS = [
  { value: "pendiente", label: "Pendientes" },
  { value: "correcciones", label: "Requieren correcciones" },
  { value: "aprobado", label: "Aprobados" },
  { value: "rechazado", label: "Rechazados" },
];

// Used for "Videos recibidos" (all) and "Moderación" (defaults to pendientes).
export const EnviosList = ({ client, meta, defaultEstado = "", testid = "red-envios", onChanged }) => {
  const [items, setItems] = useState(null);
  const [estado, setEstado] = useState(defaultEstado);
  const [prov, setProv] = useState("");
  const [cat, setCat] = useState("");
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await client.get("/envios", { params: { estado, provincia: prov, categoria: cat, q } });
      setItems(data);
    } catch (e) {
      toast.error(errMsg(e));
      setItems([]);
    }
  }, [client, estado, prov, cat, q]);

  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <div data-testid={testid}>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-5">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar…" className="pl-9" data-testid={`${testid}-buscar`} />
        </div>
        <Select value={estado} placeholder="Todos los estados" options={ESTADOS} onChange={(e) => setEstado(e.target.value)} data-testid={`${testid}-estado`} />
        <Select value={prov} placeholder="Todas las provincias" options={meta.provincias} onChange={(e) => setProv(e.target.value)} data-testid={`${testid}-provincia`} />
        <Select value={cat} placeholder="Todas las categorías" options={meta.categorias} onChange={(e) => setCat(e.target.value)} data-testid={`${testid}-categoria`} />
      </div>
      {items === null ? (
        <Spinner />
      ) : items.length === 0 ? (
        <Empty>No hay envíos {estado ? "en este estado" : "todavía"}.</Empty>
      ) : (
        <div className="bg-white border border-gray-200 divide-y">
          {items.map((e) => (
            <button key={e.id} type="button" onClick={() => setOpen(e)} className="w-full text-left p-4 hover:bg-gray-50 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4" data-testid={`envio-row-${e.id}`}>
              <span className="text-[#0A2463] shrink-0">{e.tipo === "video" ? <Film size={20} /> : <ImgIcon size={20} />}</span>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-[#0A192F] truncate">{e.titulo}</div>
                <div className="text-xs text-gray-500">{e.nombre} · {e.localidad}, {e.provincia} · {e.categoria}</div>
              </div>
              <div className="text-xs text-gray-500 shrink-0">{fmtDate(e.created_at)}</div>
              <EstadoBadge estado={e.estado} />
            </button>
          ))}
        </div>
      )}
      {open && (
        <EnvioDetail client={client} envio={open} onClose={() => setOpen(null)} onChanged={() => { load(); onChanged?.(); }} />
      )}
    </div>
  );
};

export default EnviosList;
